module.exports = __webpack_public_path__ + "app/modals/delete-page-modal.view.html";